import listMixin from '@/components/niotaClassic/listMixin';
import listOptionsPersistenceMixin from '@/components/custom/listOptionsPersistenceMixin';
import overviewEditMixin from '@/components/core/dtwin/overviewEditMixin';
import multiSearchMixin from '@/mixins/multiSearchDigitalTwins';
import { localizeDate } from '@/utils/date';
import ApiService from '@/services/apiService';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewDigitalTwinDigitalTwinList',
  mixins: [listMixin, listOptionsPersistenceMixin, overviewEditMixin, multiSearchMixin],
  data: function () {
    return {
      twinObject: {},
      showExportDialog: false,
      list: [],
      isFetching: false,
      serverItemsLength: -1,
      listPersistencePath: 'DigitalTwin.list',
      searchMode: 'multi',
      favouriteMode: 'on',
      favouriteFilter: false,
      lastSearch: '',
      tableOptions: defaultTableOptions,
      defaultTableOptions: {
        ...defaultTableOptions
      },
      disableFetchOnCreatedMixin: true
    };
  },
  computed: {
    localizedTableOptions() {
      return {
        headers: [{
          text: this.$i18n_t('Common.id'),
          value: 'id',
          align: 'right',
          sortable: true
        }, {
          text: this.$i18n_t('Common.help.titel'),
          value: 'title',
          sortable: true
        }, {
          text: this.$i18n_t('Common.hierarchyLevel'),
          value: 'hierarchyLevel',
          sortable: true
        }, {
          text: this.$i18n_t('Common.tenant'),
          sortable: true,
          value: 'tenant.name'
        }, {
          text: `${this.$i18n_t('DigitalTwin.DigitalTwin.list.states')} / ${this.$i18n_t('DigitalTwin.DigitalTwin.list.rules')}`,
          sortable: false,
          value: 'statesCount'
        },
        // {
        //   text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
        //   sortable: true,
        //   value: 'floorDtwin.title',
        // },
        {}],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    twinDuplicatePrompt() {
      if (this.twinDuplicatePrompt) {
        this.loadStates(this.twinObject);
      } else {
        this.twinDataStates = null;
      }
    },
    twinSyncPrompt() {
      if (this.twinSyncPrompt) {
        this.loadStates(this.twinObject);
      } else {
        this.twinDataStates = null;
      }
    }
  },
  methods: {
    localizeDate,
    handleRowClick(item) {
      this.$router.push(`/digitaltwin-mgmt/${item.id}`);
    },
    breadCrumbsPath() {
      return [{
        to: '/digitaltwin-mgmt',
        text: this.$i18n_t('Common.drawer.dTwins')
      }, this.$i18n_t('DigitalTwin.DigitalTwin.listView')];
    },
    deleteTwin(selected) {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.$store.state.app.dtwins = {};
      ApiService.digitalTwinDelete(selected.id).then(() => {
        this.twinDeletePrompt = false;
        this.$snack(this.$i18n_t('Common.digitalTwins.twinDeleted'), 'success');
        this.$store.state.app.dtwins = {};
        this.fetchList();
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.digitalTwins.twinDeletedFail'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    detailTableHeaderColClass(header, props) {
      let classes = [`text-${header.align || 'start'}`];
      if (header.sortable && ['title', 'id', 'floorDtwin.title'].indexOf(header.value) < 0) {
        classes.push('sortable');
      }
      const values = [header.value];
      if (props.options.sortBy && props.options.sortBy.length && values.indexOf(props.options.sortBy[0]) >= 0) {
        classes.push('active');
        if (props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0]) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }
      return classes.join(' ');
    },
    detailTableHeaderClasses(props) {
      const sortBy = props.options.sortBy && props.options.sortBy.length ? props.options.sortBy[0] : 'none';
      const sortDesc = props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0];
      return {
        text: {
          title: `header-item-sortable ${sortBy === 'title' ? 'header-active' : 'header-nonactive'}`,
          id: `header-item-sortable ${sortBy === 'id' ? 'header-active' : 'header-nonactive'}`
          // floorDtwinTitle: `header-item-sortable ${
          //   sortBy === 'floorDtwin.title' ? 'header-active' : 'header-nonactive'
          // }`,
        },
        icon: {
          title: sortBy === 'title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          id: sortBy === 'id' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive'
          // floorDtwinTitle: sortBy === 'floorDtwin.title' ? (sortDesc ? 'icon-desc' : '') : 'icon-nonactive',
        }
      };
    },
    fetchList(fromStart = false) {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const searchItems = this.searchItems.map(item => ({
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      if (!isEqual(this.lastSearch, JSON.stringify(searchItems))) {
        this.lastSearch = JSON.stringify(searchItems);
        this.tableOptions = {
          ...this.tableOptions,
          page: 1
        };
      }
      const tableOptions = fromStart ? {
        ...this.tableOptions,
        page: 1
      } : this.tableOptions;
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'id';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : false;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = page ? page - 1 : 0;
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      const filters = [];
      const accountIds = this.selectedAccounts.map(a => a.id);
      if (accountIds.length) {
        filters.push({
          type: 'tenantIds',
          ids: accountIds
        });
      }

      // persist options for next call of this page (during this browser-tab-session)
      this.$store.state.app.pageFilters = {
        ...this.$store.state.app.pageFilters,
        DigitalTwin: {
          ...(get(this.$store.state.app, 'pageFilters.DigitalTwin') || {}),
          list: {
            searchDetails: this.searchItems,
            tableOptions,
            favouriteFilter: this.favouriteFilter || false
          }
        }
      };
      ApiService.digitalTwinsFetch(this, null, null, filters, this.favouriteFilter ? ['favourites'] : null, {
        variable: sortItem,
        direction: sortDirection
      }, usedPage * usedItemsPerPage, usedItemsPerPage, searchItems).then(res => {
        this.list = res.digitaltwins;
        this.serverItemsLength = res.totalCount;
      }).catch(error => {
        console.error('Error fetching twin-list', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    updatePagination(e) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            page: e.page || defaultTableOptions.page
          },
          ...{
            perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
          }
        }
      }).catch(error => {
        console.error(error);
      });
    }
  }
};